import { Spinner } from '@zillow/constellation';

import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledSpinnerContainer = styled.div<{ height: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spaceMixin(8)};
  height: ${({ height }) => height};
`;

export type SpinnerContainerProps = {
  size?: string;
  height?: string;
};

const SpinnerContainer = ({ size = 'sm', height = '200px' }: SpinnerContainerProps) => (
  <StyledSpinnerContainer height={height} data-testid="spinnerContainer">
    {/* @ts-ignore */}
    <Spinner size={size} />
  </StyledSpinnerContainer>
);

export default SpinnerContainer;
